import type { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M7.434 2.084a4.907 4.907 0 1 0 0 9.813 4.907 4.907 0 0 0 0-9.813M1.027 6.991a6.407 6.407 0 1 1 12.813 0 6.407 6.407 0 0 1-12.813 0"
      clipRule="evenodd"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M10.944 10.5a.75.75 0 0 1 1.06 0l3.637 3.637a.75.75 0 0 1-1.06 1.061l-3.637-3.636a.75.75 0 0 1 0-1.061"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgSearch;
